<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.teacher_profile')"></pageTitle>
        <myTableFilter
          ref="myTableFilter"
          @submit="handleSubmit"
          :show="{teacher_name: true,contact_name: false, contact_phone: false}"
        />

        <myTable ref="table" :columns="columns" requestUrl="teacher-profile/list" :showPage="true">
          <template v-slot:revert="{ data }">
            <Poptip
              v-if="data.row.roll_back == 1"
              confirm
              :title="$t('confirm_revert')"
              @on-ok="handleConfirmRevert(data.row)"
            >
              <a>{{ $t("revert") }}</a>
            </Poptip>
            <span class="no_revert cursor_p" v-else>{{ $t("revert") }}</span>
          </template>
          <template v-slot:detail="{ data }">
            <!-- <a @click="handleToDetail(data.row)">{{$t("info")}}</a> -->
            <Icon
              class="cursor_p"
              @click="handleToDetail(data.row)"
              type="md-create"
              size="24"
              color="#1F8FC8"
            />
          </template>
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
export default {
  name: "",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data: function () {
    return {
      columns: [
        {
          title: this.$t("teacher_record.id"),
          key: "teacher_id",
          align: "center"
        },
        {
          title: this.$t("teacher_record.name"),
          key: "teacher_cname",
          align: "center"
        },
        {
          title: this.$t("school.last_modified"),
          key: "part_cdesc",
          align: "center"
        },
        {
          title: this.$t("teacher_record.last_changed_time"),
          key: "add_time",
          align: "center"
        },
        {
          title: this.$t("force_revert"),
          key: "revert",
          align: "center",
          slot: "revert"
        },
        {
          title: this.$t("op"),
          key: "detail",
          align: "center",
          slot: "detail"
        }
      ]
    };
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleToDetail (item) {
      this.$base.linkTo("/teacher/profile_detail", {
        id: item.log_id,
        name: item.teacher_cname
      });
    },
    handleConfirmRevert (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        "teacher-profile/back",
        { log_id: item.log_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          //添加ref 运行子组件方法
          this.$refs.table.getLoad();
        }
      );

    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
  .no_revert {
    color: #a6a6a7;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/teacher/profile/profile.vue